import styled from 'styled-components'

export const StyledCustomerReviews = {
  ImageContainer: styled.div`
    width: 100%;
    margin: 40px 0;
    aspect-ratio: 328/269;
  `,
}
